<template>
  <div>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <label>{{ $t('views.downloaddata.index.info') }}:</label>
          <b-form-group>
            <b-form-checkbox-group
              style="column-count: 3; max-height: 350px"
              stacked
              id="checkbox-group-1"
              v-model="downloadOptions"
              :options="selectedDataOptions"
              name="flavour-1"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <button type="button" class="btn btn-success" @click="downloadReport()"> {{ $t('buttons.downloadReportZip') }} </button>
          <button type="button" class="btn btn-warning float-right" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
          <button type="button" class="btn btn-warning float-right" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
        </b-col>
      </b-row>
    </b-col>
    </b-row>
  </div>
</template>

<script>
// import Loader from '../../Layout/Loader'

import ApiService from '@/utils/ApiService'

export default {
  name: 'DownloadData',
  components: {
    // Loader
  },
  data () {
    return {
      downloadOptions: Array(34).fill(0).map((e, i) => i + 1),
      selectedDataOptions: [
        { value: 1, text: this.$t('views.downloaddata.index.options.excm_case') },
        { value: 2, text: this.$t('views.downloaddata.index.options.excm_case_type') },
        { value: 3, text: this.$t('views.downloaddata.index.options.excm_custom_field') },
        { value: 4, text: this.$t('views.downloaddata.index.options.excm_custom_field_value') },
        { value: 5, text: this.$t('views.downloaddata.index.options.excm_dailyplanitem') },
        { value: 6, text: this.$t('views.downloaddata.index.options.excm_documentfile') },
        { value: 7, text: this.$t('views.downloaddata.index.options.excm_message') },
        { value: 8, text: this.$t('views.downloaddata.index.options.excm_message_contentemail') },
        { value: 9, text: this.$t('views.downloaddata.index.options.excm_note') },
        { value: 10, text: this.$t('views.downloaddata.index.options.excm_pool_tasks') },
        { value: 11, text: this.$t('views.downloaddata.index.options.excm_notification_message') },
        { value: 12, text: this.$t('views.downloaddata.index.options.excm_region') },
        { value: 13, text: this.$t('views.downloaddata.index.options.excm_region_userdata') },
        { value: 14, text: this.$t('views.downloaddata.index.options.excm_status') },
        { value: 15, text: this.$t('views.downloaddata.index.options.excm_tag') },
        { value: 16, text: this.$t('views.downloaddata.index.options.excm_task') },
        { value: 17, text: this.$t('views.downloaddata.index.options.excm_task_type') },
        { value: 18, text: this.$t('views.downloaddata.index.options.excm_team') },
        { value: 19, text: this.$t('views.downloaddata.index.options.excm_team_userdata') },
        { value: 20, text: this.$t('views.downloaddata.index.options.exsb_item_type') },
        { value: 21, text: this.$t('views.downloaddata.index.options.exsb_items') },
        { value: 22, text: this.$t('views.downloaddata.index.options.exsb_items_brand') },
        { value: 23, text: this.$t('views.downloaddata.index.options.exsb_measure') },
        { value: 24, text: this.$t('views.downloaddata.index.options.exsb_order') },
        { value: 25, text: this.$t('views.downloaddata.index.options.exsb_order_status') },
        { value: 26, text: this.$t('views.downloaddata.index.options.exsb_order_tag') },
        { value: 27, text: this.$t('views.downloaddata.index.options.exsb_position') },
        { value: 28, text: this.$t('views.downloaddata.index.options.exsb_vat_rate') },
        { value: 29, text: this.$t('views.downloaddata.index.options.fos_user') },
        { value: 30, text: this.$t('views.downloaddata.index.options.fos_user_data') },
        { value: 31, text: this.$t('views.downloaddata.index.options.fos_user_data_address') },
        { value: 32, text: this.$t('views.downloaddata.index.options.userdata_employee') },
        { value: 33, text: this.$t('views.downloaddata.index.options.client_type') },
        { value: 34, text: this.$t('views.downloaddata.index.options.document_type') }
      ]
    }
  },

  methods: {
    selectAll () {
      this.downloadOptions = Array(34).fill(0).map((e, i) => i + 1)
    },
    unSelectAll () {
      this.downloadOptions = []
    },
    downloadReport () {
      let params = {
        dataOptions: this.downloadOptions
      }
      new ApiService('data_download_csv', params).downloadFile('report' + ' ' + this.$moment().format('YYYY-MM-DD'))
    }
  }
}
</script>
